<template>
  <div
    class="card card-body d-block"
    :class="{grabbable: editMode}"
    :id="`draggable-item-${researchItem.id}`"
  >
    <div style="width: calc(100% - 35px);">
      <v-item-content
        :item="researchItem.item"
        :title="researchItem.title"
        :index="index"
        :can-copy-title="!editMode"
      />
      <div class="mt-1" v-if="researchItem.condition_groups.length > 0">
        <div
          class="badge badge-pill badge-info mr-1"
          v-for="conditionGroup in researchItem.condition_groups"
          :key="conditionGroup.id"
        >
          <i class="fa fa-filter mr-1"></i>
          {{ conditionGroup.description }}
        </div>
        <div
          v-if="researchItem.on_condition_fail === 'remove'"
          class="badge badge-pill badge-danger"
        >
          <i class="fa fa-exclamation-triangle mr-1"></i>
          {{ $t('word.screen_out') }}
        </div>
      </div>
    </div>
    <div
      class="position-absolute p-3"
      style="right: 0; top: 0"
    >
      <div v-if="isLocked">
        <i class="fa fa-lock mr-2"></i>
      </div>
      <v-dropdown-menu
        v-else-if="editMode"
        icon="ellipsis-v"
        style-type="secondary"
        size="sm"
      >
        <template v-slot:menu>
          <v-dropdown-menu-button
            v-if="isEditable"
            icon="edit"
            text="word.edit"
            @click="$emit('edit-item', researchItem)"
          />
          <v-dropdown-menu-button
            icon="copy"
            text="word.duplicate"
            @click="$emit('duplicate-item', researchItem)"
          />
          <v-dropdown-menu-button
            icon="trash"
            text="word.delete"
            text-color="danger"
            @click="$emit('delete-item', researchItem)"
          />
        </template>
      </v-dropdown-menu>
    </div>
  </div>
</template>

<script>
import DropdownMenu from '@/common/components/DropdownMenu.vue';
import DropdownMenuButton from '@/common/components/DropdownMenuButton.vue';
import ItemContent from '@/organisation/components/research/ItemContent.vue';

export default {
  name: 'ResearchItem',
  props: {
    editMode: {
      type: Boolean,
      default: true,
    },
    researchItem: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
    isLocked: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    'v-dropdown-menu': DropdownMenu,
    'v-dropdown-menu-button': DropdownMenuButton,
    'v-item-content': ItemContent,
  },
  computed: {
    isEditable() {
      if (this.isLocked) {
        return false;
      }

      if (!this.researchItem.item.organisation) {
        return false;
      }
      if (this.researchItem.has_answers) {
        return false;
      }
      return !(this.researchItem.in_researches);
    },
  },
};
</script>
